import Catalog8 from "../../assets/img/car-finder/catalog/08.jpg";
import React, { useContext, useEffect, useState } from "react";
import AddToWishListBtn from "../../components/addToWishListBtn";
import { deleteCarFromWishlist, fetchFavoriteCars } from "../../_services/carsService";
import { Link } from "react-router-dom";
import RemoveFromWishListBtn from "../../components/removeFromWishListBtn";
import { ToastContext } from "../../context/ToastContext";
import { WishlistContext } from "../../context/WishlistContext";
import ImageSlider from "../../components/ImageSlider";

function MyFavorites() {
  const { updateWishlist } = useContext(WishlistContext)
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { showToast } = useContext(ToastContext);

  useEffect(() => {
    getCars();
  }, []);

  const removeFromWishList = async (carId) => {
    try {
      await deleteCarFromWishlist(carId);
      setCars(cars.filter(car => car.id !== carId))
      updateWishlist()
      showToast("Removed from Wishlist!", "dark");
    } catch (err) {
      setError(err);
      showToast("Failed to update wishlist.", "danger");
    }
  };

  useEffect(() => {
    const onWishlistUpdate = async (event) => {
      const carId = event.detail.car.id;
      if (carId) {
        try {
          await deleteCarFromWishlist(carId);
          setCars(prevCars => prevCars.filter(car => car.id !== carId)); // Ensure latest state
          updateWishlist();
          showToast("Removed from Wishlist!", "dark");
        } catch (err) {
          setError(err);
          showToast("Failed to update wishlist.", "danger");
        }
      }
    };
  
    window.addEventListener("wishlistUpdated", onWishlistUpdate);
  
    return () => {
      window.removeEventListener("wishlistUpdated", onWishlistUpdate);
    };
  }, [updateWishlist, showToast]);
 

  const getCars = async () => {
    try {
      const data = await fetchFavoriteCars();
      setCars(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  

  return (
    <>
      <div className="d-flex align-items-center justify-content-between pb-4 mt-5 mb-2">
        <h2 className="me-3 mb-0">{cars.length} Favorites</h2>
      </div>
      <div className="d-sm-flex align-items-center justify-content-between pb-4 mb-2">
        <div className="d-flex align-items-center me-sm-4">
          <label
            className="fs-sm fw-normal text-nowrap mb-0 me-2 pe-1 form-label"
            for="sortbyTop"
          >
            <i className="fi-arrows-sort mt-n1 me-2"></i>Sort by:
          </label>
          <select className="me-sm-4 form-select form-select-sm" id="sortbyTop">
            <option value="newest">Newest</option>
            <option value="popular">Popular</option>
            <option value="priceLH">Price: Low - High</option>
            <option value="priceHL">Price: High - Low</option>
          </select>
          <div
            className="d-none d-md-block border-end border-light"
            style={{ height: "1.25rem" }}
          ></div>
        </div>
      </div>

      <div className="row">
        {cars.map((car, index) => (
          <div className="col-lg-4 mb-4">
            <Link
              className="text-decoration-none"
              key={index}
              to={`/auctions/${car.id}`}
            >
              <div className="card card-hover h-100">
                <div className="card-img-top card-img-hover">
                  <a className="img-overlay" href="#"></a>
                  <div className="position-absolute start-0 top-0 pt-3 ps-3">
                    <span className="d-table badge bg-info">New</span>
                  </div>
                  
                  {/*
                  This removed button gets hidden behind the AddToWishList button
                  <div className="content-overlay end-0 top-0 pt-3 pe-3">
                    <RemoveFromWishListBtn removeFromWishList={removeFromWishList} car={car}></RemoveFromWishListBtn>
                  </div>
                  */}
                  {/* <img src={Catalog8} alt="Image" /> */}
                  <ImageSlider car={car} />
                </div>
                <div className="card-body px-0">
                  <div className="d-flex px-3 align-items-center justify-content-between pb-1">
                  <div className="text-primary fw-bold mb-1">
                          {car.current_bid_amount != null 
                            ? car.current_bid_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  
                            : "N/A"}
                  </div>
                    <span className="fs-sm me-3">
                      {car.odometer_reading >= 1e6 ? (car.odometer_reading / 1e6).toFixed(1) + 'M' : car.odometer_reading >= 1e3 ? (car.odometer_reading / 1e3).toFixed(1) + 'K' : car.odometer_reading?.toString()} mi
                    </span>
                  </div>
                  <h3 className="h6 mb-1 px-3">
                    <a className="nav-link">
                      {car.year} {car.make} {car.model}
                    </a>
                  </h3>
                  {/* <div className="fs-sm text-muted px-3">
                    <i className="fi-map-pin me-1"></i> Boston, 560068
                  </div> */}
                </div>

                <div className="card-footer px-0 bg-transparent border-0 pt-0 pb-3">
                  <div className="border-top pt-3 px-3">
                    <div className="row row-cols-2 g-2 fs-sm">
                      <div className="col d-flex align-items-center gap-2">
                        <i className="fi-petrol"></i>
                        {car.fuel_type}
                      </div>
                      <div className="col d-flex align-items-center gap-2">
                        <i className="fi-gearbox"></i>
                        {car.transmission}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className="d-flex align-items-center justify-content-between py-2">
        <div className="d-flex align-items-center me-sm-4">
          {/* <label
            className="fs-sm fw-normal text-nowrap mb-0 me-2 pe-1 form-label"
            for="sortbyBottom"
          >
            <i className="fi-arrows-sort mt-n1 me-2"></i>Sort by:
          </label>
          <select
            className="me-sm-4 form-select form-select-sm"
            id="sortbyBottom"
          >
            <option value="newest">Newest</option>
            <option value="popular">Popular</option>
            <option value="priceLH">Price: Low - High</option>
            <option value="priceHL">Price: High - Low</option>
          </select>
          <div
            className="d-none d-md-block border-end border-light"
            style={{ height: "1.25rem" }}
          ></div> */}
        </div>
      </div>
    </>
  );
}

export default MyFavorites;
